export default {
  label: "User Management",
  userAuthorization: "User Authorization",
  tabs: {
    pendingUserRequests: "Pending User Requests",
    userAndRolesAssignment: "User and Roles Assignment",
  },
  assignRolesToUser: {
    label: "Roles To User Assignment",
  },
  userRoleManager: {
    inviteUser: "Invite User",
    label: "User Role Manager",
    roleName: "Role Name",
    selectRole: "Select Role",
    backToUM: "Back to User Management",
    backToUserRolesManager: "Back to User Role Manager",
    assignedTo: "Assigned to",
    noUsersAssignedMessage: "There are no users assigned to this role yet.",
    permissions: "Permissions",
    createdUserRole: "Your user role has been succesfully created.",
    useRoleCreate: "User role created",
    discardChanges: "Discard changes",
    discardMessage:
      "You've commited changes that are not saved. Are you sure you want to quit this page and leave those changes unsaved? ",
  },
  button: {
    create: {
      role: "New role",
      user: "Create User",
    },
  },
  form: {
    label: {
      role: "Edit Role",
      user: "Edit User",
      deleteUserRole: "Delete user role",
      editRole: "Edit role",
    },
    message: {
      continueDeleteMessage: "Are you sure you want to continue?",
      userBlockMessage: "Are you sure you want to block this user?",
      userUnblockMessage: "Are you sure you want to unblock this user?",
      userRoleDeleteMessagePt1: "This user role is currently assignet to",
      userRoleDeleteMessagePt2: "They will no longer have access to certain app areas.",
      userCreationSshAccess:
        "The new user can access the application only via SSH key. However, login is disabled until the user is created in Identity Access Management provider.",
      userCreationIdamRequired:
        "Please complete user creation in Identity Access Management provider first to enable standard login access.",
    },
    edit: {
      tabLabel: {
        editRole: "Change Role",
        assignScope: "Assign Permissions",
        assignUser: "Assign Users",
      },
      listLabel: {
        assigned: "Assigned",
        unassigned: "Unassigned",
      },
    },
  },
  table: {
    column: {
      description: "Description",
      email: "Email",
      firstName: "First Name",
      lastName: "Last Name",
      name: "Name",
      role: "Roles of the User",
      tenant: "Tenant / Company",
      value: "Value",
      userRole: "User role name",
      roleDescription: "Role description",
      pendingRequestsAction: "Action",
    },
  },
};
